import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import examReducer from './slices/examSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    exam: examReducer,
  },
});

export default store; 